import { useMemo } from 'react';
import type { Persona } from '../types/persona';

/**
 * Returns the top-N most-frequent tags across the personas array.
 * Sorted descending by count.
 */
export function useTopTags(personas: Persona[], n: number = 12): string[] {
  return useMemo(() => {
    const counts = new Map<string, number>();
    personas.forEach(p => {
      (p.tags || []).forEach(tag => {
        counts.set(tag, (counts.get(tag) || 0) + 1);
      });
    });
    return Array.from(counts.entries())
      .sort((a, b) => b[1] - a[1])
      .slice(0, n)
      .map(([tag]) => tag);
  }, [personas, n]);
}
